import { t } from "@/i18n-js/instance";

export const AdminDashboardPage = () => (
  <div className="flex min-h-screen items-center justify-center">
    <h1 className="text-2xl font-bold">{t("sidebar_admin_dashboard")}</h1>
  </div>
);
